import * as React from 'react'
import { ScaleLoader } from 'react-spinners';

export const Loading = () =>
    <div className = "ViolationHistoryAvailability">
        <ScaleLoader
          color={'#ff6e40'}
          loading={true}
          width={2}
          height={20}
        />
    </div>


// WEBPACK FOOTER //
// ./src/components/ViolationsHistoryDetails/Loading.tsx